import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'components/Link';
import { bindGa } from 'helpers/analytics';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import { getSiteDomain, debounce } from 'utils/common';
import makeRequest from 'utils/makeRequest';
import {
  processRecentSearch,
  getRecentSearch,
  removeRecentSearchItem,
  filterDuplicateTrendingEntry,
  isSearchedKeywordValid,
  replaceSpaceWitHyphen,
} from 'utils/searchOverlayUtils';
import { SEARCH_TOP_TREND_API } from 'constants/index';
import s from './Search.scss';
import { getSearchKeywordSuggestionApi } from './config';
import { loadVideosearchDataCount } from '../../../../reduxUtils/modules/videosearch';
import { loadtopvideos } from '../../../../reduxUtils/modules/topvideos';

class Search extends React.Component {
  static renderVideoResultItem(resultItem) {
    // const resultLink = Search.getItemLink(resultItem);
    const { frmmidarticle } = this.props;
    const selectedCss = resultItem.isSelected ? 'selected' : '';
    return (
      <li key={resultItem.url} className={s[selectedCss]}>
        <Link
          data-newga={`${this.state.categoryForSearchGA}#${
            frmmidarticle
              ? 'Widget-Search-Initiate-Auto_Suggestion'
              : 'NavBar-Search-Initiate-Auto_Suggestion'
          }#${this.state.link}-${resultItem.title || ''}`}
          to={resultItem.url}
          onClick={() => processRecentSearch(resultItem.title)}
          data-setgacategory
        >
          {resultItem.title || ''}
        </Link>
      </li>
    );
  }

  static findL1FromURL(pathname) {
    return (
      pathname.length > 1 &&
      pathname.split('/').length > 0 &&
      pathname.split('/')[1]
    );
  }

  componentDidMount() {
    const { searchTrendingData, frmmidarticle } = this.props;
    if (
      typeof window !== 'undefined' &&
      window.location &&
      window.location.href
    ) {
      const l1Path =
        (window.location.pathname &&
          Search.findL1FromURL(window.location.pathname)) ||
        '';
      this.setState({ link: window.location.href });
      this.setState({
        categoryForSearchGA:
          (typeof window !== 'undefined' && window.categoryForSearchGA) ||
          `WEB-TOI-Others-${l1Path}`,
      });
    }
    if (
      !searchTrendingData &&
      !(
        searchTrendingData &&
        searchTrendingData.items &&
        Array.isArray(searchTrendingData.items) &&
        searchTrendingData.items.length
      )
    ) {
      this.getSearchTrendingData();
    } else {
      this.setState({ searchTrendingData });
    }

    const recentSearches = getRecentSearch();
    this.setState({
      recentSearches,
      shouldShowSearchBox: !!frmmidarticle,
    });
  }

  getHighlightedResults(resultText) {
    const { searchedValue } = this.state;
    const searchedValueFirstIndex = resultText
      .toLowerCase()
      .indexOf(searchedValue.toLowerCase());
    return (
      <React.Fragment>
        {resultText.substring(0, searchedValueFirstIndex)}
        {
          <span className={s.resultSearchString}>
            {resultText.substring(
              searchedValueFirstIndex,
              searchedValueFirstIndex + searchedValue.length,
            )}
          </span>
        }
        {resultText.substring(
          searchedValueFirstIndex + searchedValue.length,
          resultText.length,
        )}
      </React.Fragment>
    );
  }

  renderResultItem(resultItem) {
    const { highlightSearchedWordInResult } = this.props;
    const resultLink = Search.getItemLink(resultItem);
    const resultText = resultItem[0] || '';
    const selectedCss = resultItem.isSelected ? 'selected' : '';
    if (!isSearchedKeywordValid(resultText)) {
      return null;
    }
    return (
      <li key={resultItem[0]} className={s[selectedCss]}>
        <Link
          to={resultLink}
          data-setgacategory
          onClick={e => {
            this.handSearchSuggestionClick(e, resultText);
          }}
        >
          {highlightSearchedWordInResult
            ? this.getHighlightedResults(resultText)
            : resultText}
        </Link>
      </li>
    );
  }

  static getItemLink(resultItem) {
    if (!(resultItem && resultItem instanceof Array && resultItem[0])) {
      return '';
    }
    const resulttxt = resultItem[0] && replaceSpaceWitHyphen(resultItem[0]);
    if (!resulttxt) return '';
    const domain = getSiteDomain();
    const resultLink = `${domain}/topic/${resulttxt}`;
    return resultLink;
  }

  constructor(props) {
    super(props);
    this.state = {
      shouldShowSearchBox: false,
      lastSearchKeyword: '',
      searchResults: [],
      link: '',
      categoryForSearchGA: '',
      recentSearches: [],
      searchTrendingData: {},
      emptyField: true,
      isSearchButtonDisable: false,
    };
    this.fetchSearchData = debounce(this.fetchSearchData.bind(this), 200);
  }

  onKeyDown(event) {
    const { frmmidarticle } = this.props;
    /*
			up = 38
			down = 40
			27 = escape
		*/
    /*
			ToDo - Add Debounce
		*/
    const keyCode = event.keyCode || event.which;
    if (keyCode === 40 || keyCode === 38) {
      this.markSelectedItem(keyCode);
    } else if (keyCode === 27 && !frmmidarticle) {
      this.setState({
        shouldShowSearchBox: false,
      });
    }
  }

  @bindGa({})
  onClick() {
    if (typeof this.props.onClickOnSearchBtn !== 'undefined') {
      this.props.onClickOnSearchBtn();
    }
    if (this.state.shouldShowSearchBox && this.searchField) {
      this.searchField.blur();
    }
    const { frmmidarticle } = this.props;
    if (!this.state.shouldShowSearchBox && !frmmidarticle) {
      this.fireGaforTrendingView();
      this.fireGaforRecentSearchView();
    }
    this.setState(
      {
        shouldShowSearchBox: !this.state.shouldShowSearchBox,
        searchedValue: '',
      },
      () => {
        if (this.searchField && this.state.shouldShowSearchBox) {
          this.searchField.focus();
        } else {
          this.searchField.blur();
          this.setState({
            searchResults: [],
            videoSearchResultData: [],
          });
        }
      },
    );

    this.searchField.value = '';
  }

  markSelectedItem() {
    const results = Object.assign([], this.state.searchResults);
    const selected = results.filter(item => item.isSelected);
    let indexToHighlight;
    if (!selected.length) {
      indexToHighlight = 0;
    } else {
      const currentHighlightedIndex = results.indexOf(selected[0]);
      if (currentHighlightedIndex === results.length - 1) {
        indexToHighlight = 0;
      } else {
        results[currentHighlightedIndex + 1].isSelected = true;
      }

      results[indexToHighlight].isSelected = true;
      results[currentHighlightedIndex].isSelected = false;
    }

    this.setState({
      searchResults: results,
    });
  }
  static formatVideoSearchData(data = {}) {
    if (data.Documents instanceof Array) {
      return data.Documents.map(item => ({
        title: item.title.value,
        url: `https://timesofindia.indiatimes.com/${item.seopath}/videoshow/${
          item.msid
        }.cms`,
      })).filter((item, index) => index < 7);
    }
    return [];
  }

  fetchSearchData = url =>
    makeRequest
      .get(url, {}, 'skipfeedengine')
      .then(response => {
        if (response && response.data) {
          if (this.props.frmmidarticle && response.data.length > 5) {
            this.setState({
              searchResults: response.data.slice(0, 5),
            });
          } else {
            this.setState({
              searchResults: response.data,
            });
          }
        }
      })
      .catch(e => {
        console.log(e);
      });

  fetchSearchResults = event => {
    const apiDetails = getSearchKeywordSuggestionApi();
    const { toipLayout } = this.props;
    let searchKeyword = event.target.value || '';
    this.setState({
      searchedValue: searchKeyword,
    });
    searchKeyword = searchKeyword.trim();
    if (toipLayout) {
      sendGaThroughProps({
        data: {
          gaCategory: 'WEB-Prime-AS',
          gaAction: 'NavBar-Search',
          gaLabel: `Initiate | ${searchKeyword}`,
        },
      });
    }

    let url = `${apiDetails.endpoint}?q=${searchKeyword}`;
    apiDetails.params.forEach(item => {
      url += `&${item.key}=${item.value}`;
    });
    if (window.location.href.indexOf('/videos') > 0 && !this.props.isWapView) {
      makeRequest
        .get(
          `/video_search_api/feedtype-sjson,sortOrder-score+desc,query-${searchKeyword},page-1.cms`,
          { isMobile: this.props.isWapView },
        )
        .then(response => response.data)
        .then(data => {
          this.state.videoSearchResultData = [];
          this.setState({
            videoSearchResultData: Search.formatVideoSearchData(data),
          });
        })
        .catch(() => {
          //console.log(err)
        });
      return;
    }
    if (!searchKeyword) {
      this.setState({
        searchResults: [],
        emptyField: true,
      });
    } else {
      this.setState({ emptyField: false });
    }
    if (!searchKeyword || searchKeyword === this.state.lastSearchKeyword) {
      return;
    }

    this.setState({
      lastSearchKeyword: searchKeyword,
    });
    if (isSearchedKeywordValid(searchKeyword)) {
      this.setState({ isSearchButtonDisable: false });
      // makeRequest
      //   .get(url, {}, 'skipfeedengine')
      //   .then(response => {
      //     if (response && response.data)
      //       this.setState({
      //         searchResults: response.data,
      //       });
      //   })
      //   .catch(e => {
      //     console.log(e);
      //   });
      this.fetchSearchData(url);
      // jsonp(url, null, (err, data) => {
      //   if (
      //     data &&
      //     data instanceof Array &&
      //     data.length &&
      //     data[1] &&
      //     data[1] instanceof Array
      //   ) {
      //     this.setState({
      //       searchResults: data[1],
      //     });
      //   }
      // });
    } else {
      this.setState({
        searchResults: [],
        isSearchButtonDisable: true,
      });
    }
  };
  renderSearchResults(data) {
    if (!(data && data instanceof Array)) {
      return null;
    }

    return (
      <ul className={s.nav_autosuggest_result}>
        {data.map(item => this.renderResultItem(item))}
      </ul>
    );
  }
  static renderVideoSearchResults(data = []) {
    return (
      <ul className={s.nav_autosuggest_result}>
        {data.map(item => Search.renderVideoResultItem(item))}
      </ul>
    );
  }

  onFormSubmitVideos(event) {
    event.preventDefault();
    this.setState({
      shouldShowSearchBox: false,
    });
    const obj = {
      searchitem: this.searchField.value,
      isWapView: this.props.isWapView,
    };
    this.props.loadVideosearchDataCount(obj);
    this.props.loadtopvideos(this.props.isWapView);
    return false;
  }

  @bindGa({})
  onFormSubmit(event) {
    event.preventDefault();
    // const resultLink = Search.getItemLink(this.state.searchResults[0]);
    // if (resultLink) {
    //   window.location.href = resultLink;
    // }
    const { frmmidarticle } = this.props;
    if (!isSearchedKeywordValid(this.searchField.value)) return false;
    if (this.searchField.value) {
      sendGaThroughProps({
        data: {
          gaCategory: this.state.categoryForSearchGA,
          gaAction: `${
            frmmidarticle
              ? 'Widget-Search-Initiate-Manually_Entered'
              : 'NavBar-Search-Initiate-Manually_Entered'
          }`,
          gaLabel: `${window.location.href}-${this.searchField.value}`,
        },
      });
      processRecentSearch(this.searchField.value);
      window.location.href = `/topic/${this.searchField.value}`;
    }
    return false;
  }

  handSearchSuggestionClick = (e, searchKey) => {
    if (e) {
      e.preventDefault();
    }
    const { frmmidarticle } = this.props;
    sendGaThroughProps({
      data: {
        gaCategory: this.state.categoryForSearchGA,
        gaAction: `${
          frmmidarticle
            ? 'Widget-Search-Initiate-Auto_Suggestion'
            : 'NavBar-Search-Initiate-Auto_Suggestion'
        }`,
        gaLabel: `${window.location.href}-${searchKey}`,
      },
    });
    processRecentSearch(searchKey);
    window.location.href = `/topic/${searchKey}`;
  };

  getRecentsearchList = items => {
    if (Array.isArray(items) && items.length) {
      return items.map(item => this.getRecentSearchLi(item));
    }
    return null;
  };

  getRecentSearchLi = item => (
    <li>
      <a
        href={`/topic/${replaceSpaceWitHyphen(item)}`}
        onClick={e => {
          e.preventDefault();
          this.handleRecentSearchClick(
            item,
            `/topic/${replaceSpaceWitHyphen(item)}`,
          );
        }}
      >
        {item}
      </a>
      <i
        className={s.removeIcon}
        onClick={() => {
          this.handleRemoveRecentSearchItem(item);
        }}
      />
    </li>
  );

  async getSearchTrendingData() {
    try {
      const response = await makeRequest.get(SEARCH_TOP_TREND_API);
      const { data: searchTrendingData } = response;
      const trendingData = filterDuplicateTrendingEntry(searchTrendingData);
      this.setState({
        searchTrendingData: trendingData,
      });
    } catch (err) {
      console.log(err);
    }
  }

  handleRecentSearchClick = (searchkey, path) => {
    if (isSearchedKeywordValid(searchkey)) {
      sendGaThroughProps({
        data: {
          gaCategory: this.state.categoryForSearchGA,
          gaAction: `NavBar-Search-Initiate-Recent_Searches`,
          gaLabel: `${window.location.href}-${searchkey}`,
        },
      });
      processRecentSearch(searchkey);
      window.location.href = path;
    }
  };

  handleTrendingSearchClick = (searchkey, path) => {
    if (isSearchedKeywordValid(searchkey)) {
      sendGaThroughProps({
        data: {
          gaCategory: this.state.categoryForSearchGA,
          gaAction: `NavBar-Search-Initiate-Trending_Topic`,
          gaLabel: `${window.location.href}-${searchkey}`,
        },
      });
      processRecentSearch(searchkey);
      window.location.href = path;
    }
  };

  handleRemoveRecentSearchItem = searchKey => {
    sendGaThroughProps({
      data: {
        gaCategory: this.state.categoryForSearchGA,
        gaAction: `NavBar-Search-Recent_Searches_Delete`,
        gaLabel: `${window.location.href}`,
      },
    });
    this.setState({ recentSearches: removeRecentSearchItem(searchKey) });
  };

  fireGaforTrendingView = () => {
    const { searchTrendingData } = this.state;
    if (
      searchTrendingData &&
      Array.isArray(searchTrendingData.items) &&
      searchTrendingData.items.length
    ) {
      sendGaThroughProps({
        data: {
          gaCategory: this.state.categoryForSearchGA,
          gaAction: `NavBar-Search-Trending_Topic_View`,
          gaLabel: `${window.location.href}`,
        },
      });
    }
  };

  fireGaforRecentSearchView = () => {
    const recentSearches = getRecentSearch();
    if (
      recentSearches &&
      Array.isArray(recentSearches) &&
      recentSearches.length
    ) {
      sendGaThroughProps({
        data: {
          gaCategory: this.state.categoryForSearchGA,
          gaAction: `NavBar-Search-Recent_Searches_View`,
          gaLabel: `${window.location.href}`,
        },
      });
    }
  };

  render() {
    const {
      sticky,
      frmmidarticle,
      toipLayout,
      placeholder,
      isPrimeUserLayout,
      fromEtimes,
    } = this.props;
    const {
      recentSearches,
      searchTrendingData,
      emptyField,
      isSearchButtonDisable,
    } = this.state;
    const searchListUI = this.getRecentsearchList(recentSearches);

    const searchWrapperActiveClasses = this.state.shouldShowSearchBox
      ? 'active'
      : '';
    const gaLabelForSearchIcon = this.state.shouldShowSearchBox
      ? 'Close'
      : 'Click';
    // const gaLabelForSearchKeyword =
    //   this.state.searchResults && this.state.searchResults.length > 0
    //     ? this.state.searchResults[0][0]
    //     : '';
    return (
      <div
        className={`${frmmidarticle ? 'mid_article_search' : ''} ${
          fromEtimes ? s.etimesSearchForm : ''
        } ${classNames({
          [`${s['search-form']}`]: true,
          [`${s[this.props.theme]}`]: this.props.theme,
          [`${s[searchWrapperActiveClasses]}`]: true,
          [`${s.sticky}`]: sticky,
          [`${s.primeuserlayout}`]: isPrimeUserLayout,

          // [`${s[this.props.colorTheme]}`]: this.props.colorTheme,
        })}`}
      >
        <div
          className={`${
            !frmmidarticle ? `contentwrapper small rel` : `search_input_fix`
          }`}
        >
          {!frmmidarticle && (
            <span
              onClick={event => this.onClick(event)}
              className={`${toipLayout ? s.searchBtn : s['search-btn']}`}
              data-newga={
                toipLayout
                  ? `NavBar-Search#${gaLabelForSearchIcon}#WEB-Prime-AS`
                  : `${
                      this.state.categoryForSearchGA
                    }#NavBar-Search-${gaLabelForSearchIcon}#${this.state.link}`
              }
              data-setgacategory
            />
          )}
          <div
            className={`${s.inner} ${
              this.state.shouldShowSearchBox || frmmidarticle
                ? ''
                : s.hideSearchBox
            }`}
          >
            <form
              data-plugin="navsearchboxvalidate"
              name="frmsearch1"
              onSubmit={event => {
                if (
                  window.location.href.indexOf('/videos') > 0 &&
                  !this.props.isWapView
                ) {
                  this.onFormSubmitVideos(event);
                } else {
                  this.onFormSubmit(event);
                }
              }}
              // data-newga={`NavBar-Search#Search-Initiate-${gaLabelForSearchKeyword}`}
              data-setgacategory
            >
              <input
                ref={el => {
                  if (el) {
                    this.searchField = el;
                  }
                }}
                onKeyDown={event => this.onKeyDown(event)}
                onChange={event => this.fetchSearchResults(event)}
                tabIndex="-1"
                autoFocus={!frmmidarticle && 'autoFocus'}
                id="searchField"
                autoComplete="off"
                name="query"
                className="textbox"
                placeholder={placeholder || 'Latest news, videos, photos'}
                type="text"
                onClick={() => {
                  if (frmmidarticle) {
                    sendGaThroughProps({
                      data: {
                        gaCategory: this.state.categoryForSearchGA,
                        gaAction: 'Widget-Search-Click',
                        gaLabel: `${window.location.href}`,
                      },
                    });
                  }
                }}
              />
              <input
                value="search"
                className={`submit ${isSearchButtonDisable ? s.disable : ''}`}
                type="submit"
              />
              <input type="hidden" value="" name="type" />
              <input type="hidden" value="233446897" name="catkey" />
              <input type="hidden" value="3" name="search" />
              <input type="hidden" value="" name="sitesearch" />
              <input type="hidden" value="1" name="fields" />
              <input type="hidden" value="2" name="searchtype" />
              <input type="hidden" value="2" name="article" />
              <input value="0" type="hidden" name="search1" />
              {/* <br className="clearfix"/> */}
            </form>
            <div className={s.search_list}>
              {searchListUI &&
                emptyField &&
                !frmmidarticle && (
                  <div className={s.search_listing}>
                    <ul
                      className={`${s.nav_autosuggest_result} ${s.recent_ul}`}
                    >
                      <span className={s.ttl}>
                        <em className={s.recentIcon} />
                        Recent Searches
                      </span>
                      {searchListUI}
                    </ul>
                  </div>
                )}
              {!frmmidarticle &&
                searchTrendingData &&
                searchTrendingData.items &&
                Array.isArray(searchTrendingData.items) &&
                searchTrendingData.items.length &&
                emptyField && (
                  <div className={s.search_listing}>
                    <ul className={s.nav_autosuggest_result}>
                      <span className={s.ttl}>
                        <em className={s.trendingIcon} />
                        Trending
                      </span>
                      {searchTrendingData.items
                        .filter((v, i) => i < 5)
                        .map(item => (
                          <li>
                            <a
                              href={`/topic/${replaceSpaceWitHyphen(item.hl)}`}
                              onClick={e => {
                                e.preventDefault();
                                this.handleTrendingSearchClick(
                                  item.hl,
                                  `/topic/${replaceSpaceWitHyphen(item.hl)}`,
                                );
                              }}
                            >
                              {item.hl}
                            </a>
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
            </div>

            {!emptyField &&
            this.state.searchResults &&
            this.state.searchResults.length
              ? this.renderSearchResults(this.state.searchResults)
              : null}
            {!emptyField &&
              this.state.videoSearchResultData &&
              Search.renderVideoSearchResults(this.state.videoSearchResultData)}
          </div>
        </div>
      </div>
    );
  }
}

Search.propTypes = {
  theme: PropTypes.string,
  loadVideosearchDataCount: PropTypes.func.isRequired,
  // colorTheme: PropTypes.string,
  isWapView: PropTypes.bool.isRequired,
  loadtopvideos: PropTypes.func.isRequired,
  highlightSearchedWordInResult: PropTypes.bool,
  sticky: PropTypes.bool,
  toipLayout: PropTypes.bool,
  placeholder: PropTypes.string,
  onClickOnSearchBtn: PropTypes.func,
  isPrimeUserLayout: PropTypes.bool,
};

Search.defaultProps = {
  theme: undefined,
  sticky: false,
  highlightSearchedWordInResult: false,
  toipLayout: false,
  placeholder: undefined,
  onClickOnSearchBtn: () => {},
  isPrimeUserLayout: false,
};
const mapDispatchtoProps = dispatch => ({
  loadVideosearchDataCount: params => {
    dispatch(loadVideosearchDataCount(params));
  },
  loadtopvideos: isWapView => {
    dispatch(loadtopvideos(isWapView));
  },
});
export default connect(undefined, mapDispatchtoProps)(Search);
